import React, { useMemo } from 'react'
import { useFragment, graphql } from 'react-relay'

import { getTokenValue, Token } from 'tamagui'

import { UserPrimaryPhoto, UserDefaultPhoto } from '../User/UserPrimaryPhoto'

import { PresentationPresenterPhotoNew_presentation$key } from './__generated__/PresentationPresenterPhotoNew_presentation.graphql'

export const PresentationPresenterPhoto = ({
  presentation,
  size = '$5',
}: {
  presentation: PresentationPresenterPhotoNew_presentation$key
  size: Token
}) => {
  const data = useFragment(
    graphql`
      fragment PresentationPresenterPhotoNew_presentation on Presentation
      @argumentDefinitions(
        imageSize: { type: "Int", defaultValue: 100 }
        dpr: { type: "Int", defaultValue: 3 }
      ) {
        presenter {
          ...UserPrimaryPhotoNew_user
            @arguments(imageSize: $imageSize, dpr: $dpr)
        }
        guestPresenterAvatarUrl(
          transform: { w: $imageSize, h: $imageSize, dpr: $dpr }
        )
      }
    `,
    presentation
  )

  const parsedSize = useMemo(() => {
    return getTokenValue(size, 'size') as number
  }, [size])

  if (data.presenter) {
    return <UserPrimaryPhoto user={data.presenter} size={size} />
  }

  return (
    <UserDefaultPhoto
      defaultAvatarUrl={data.guestPresenterAvatarUrl}
      width={parsedSize}
      height={parsedSize}
      borderRadius={parsedSize}
    />
  )
}
